import { render, staticRenderFns } from "./MobileNewsDetail.vue?vue&type=template&id=4a5e2a6a&scoped=true&"
import script from "./MobileNewsDetail.vue?vue&type=script&lang=js&"
export * from "./MobileNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MobileNewsDetail.vue?vue&type=style&index=0&id=4a5e2a6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5e2a6a",
  null
  
)

export default component.exports